import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Checkbox, Dropdown, Space, Table, Tag } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PendingApprovalRedeemTimeTable = ({
  modalFlag = true,
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onReturn = () => { },
  onApprove = () => { },
  onReject = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('req_id.req_id')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      visible: true,
    },
    {
      title: <div className="text-table">{t('name-surname')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: true,
      render: (text, record) => <span>{record.employee.nameAndSurname}</span>
    },
    {
      title: <div className="text-table">{t('pending_approval_redeem_time.label.redeem-date')}</div>,
      dataIndex: "redeemDate",
      key: "redeemDate",
      visible: true,
    },

    {
      title: <div className="text-table">{t('description.description')}</div>,
      dataIndex: "description",
      key: "description",
      visible: true,
    },
    {
      title: <div className="text-table">{t('status.status')}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      visible: true,
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />

        // let tagColor = "green";
        // if (record.approveStatusEn === "Pending") {
        //   tagColor = "blue";
        // } else if (record.approveStatusEn === "Rejected" || record.approveStatusEn === "Cancelled") {
        //   tagColor = "red";
        // }
        // return <Tag color={tagColor}>{record.approveStatusEn}</Tag>;
      },
    },
    {
      title: "",
      key: "action",
      align: "center",
      visible: modalFlag,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "2",
                  onClick: () => onApprove(record),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "1",
                  onClick: () => onReject(record),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const visibleColumns = columns.filter((col) => col.visible);

  return (
    <TableAntd
      loading={isLoading}
      style={{ backgroundColor: "white", width: "100%" }}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={visibleColumns}
      onChange={onChange}
    />
  );
};

export default PendingApprovalRedeemTimeTable;
